import { render, staticRenderFns } from "./lottery-3d.vue?vue&type=template&id=33a8101c&scoped=true&"
import script from "./lottery-3d.vue?vue&type=script&lang=js&"
export * from "./lottery-3d.vue?vue&type=script&lang=js&"
import style0 from "./lottery-3d.vue?vue&type=style&index=0&id=33a8101c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a8101c",
  null
  
)

export default component.exports